





























































import Vue from 'vue'
import { getFileContentOrDownload } from '@/components/ViewDetail/viewdetail'
import { previewMode } from '@/utils/commonDef'
import { ServiceProxy as ResourceServiceProxy } from '@/service-proxies/app-v2/resource.service-proxies'
const resourceService = new ResourceServiceProxy()
export default Vue.extend({
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => ({})
    },
    parentid: {
      type: String,
      default: '0'
    },
    footer: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      message: '',
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 16 }
      },
      encodeType: 'UTF-8',
      encodingTypes: ['ANSI', 'UTF-16 LE', 'UTF-16 BE', 'UTF-8', 'GBK', 'Big5', ' Shift-JIS'],
      type: 1,
      canEditSuffix: previewMode.text,
      imageSuffix: previewMode.image,
      content: null
    }
  },
  watch: {
    'item.id': {
      handler() {
        const name = this.item.displayName
        if (name && name.indexOf('.') != -1) {
          var a = /.*\.(.*)$/
          const suffix = a.exec(this.item.displayName)[1]
          if (this.isImage(suffix)) {
            this.type = 2
            this.viewDetail()
          } else if (this.canEdit(this.item.displayName)) {
            this.type = 1
            this.viewDetail()
          } else if (suffix.toLowerCase() === 'pdf') {
            this.getPdfUrl()
          }
        } else if (name && name.indexOf('.') === -1) {
          this.type = 1
          this.viewDetail()
        }
      }
    }
  },
  methods: {
    onClose() {
      this.form.resetFields()
      this.encodeType = 'UTF-8'
      this.$emit('close', false)
    },
    changeEdit() {
      this.$emit('change')
    },
    getPdfUrl() {
      const file = this.item
      resourceService.statFileUsingGET(file.objectKey).then((res) => {
        this.content = res.data.link
      })
    },
    canEdit(name) {
      let bool = false
      if (name && name.indexOf('.') != -1) {
        const a = /.*\.(.*)$/
        const suffix = a.exec(name)[1]
        bool = this.canEditSuffix.includes(suffix.toLowerCase()) || suffix === 'json'
      } else {
        bool = true
      }
      return bool
    },
    isImage(suffix) {
      let bool = false
      if (suffix) {
        bool = this.imageSuffix.includes(suffix.toLowerCase())
      }
      return bool
    },

    viewDetail() {
      const file = this.item
      getFileContentOrDownload(
        file.displayName,
        file.objectKey,
        this.type,
        this.encodeType,
        file.contentType
      ).subscribe((res) => {
        this.message = res
      })
    },
    selectType(e) {
      this.encodeType = e
      this.viewDetail()
    }
  }
})
